import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import newsPostComponent from './newsPost.component';

const newsPostModule = angular
  .module('newsPost', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.news.newsPost', {
      url: '/{date:[0-9-]{10}}/{newsPostSlug:[0-9a-zA-Z_-]{1,200}}',
      resolve: {
        newsPost: ($stateParams, ApiService) =>
          ApiService.entitySearchOne({
            q: `schema:newsPost AND slug:"${$stateParams.newsPostSlug}" AND publishedAt:${$stateParams.date}*`,
            children: 1,
          }).then((newsPost) =>
            ApiService.entitySearchOne({
              q: `schema:newsPost AND sort.publishedAt:[0 TO ${+new Date(
                newsPost.publishedAt
              )}] AND !slug:"${$stateParams.newsPostSlug}"`,
              sort: '-sort.publishedAt<number>',
              limit: 1,
              include_docs: true,
            }).then((nextNewsPost) => {
              newsPost.next = nextNewsPost;
              return newsPost;
            })
          ),
      },
      views: {
        'content@index': {
          component: 'newsPost',
        },
      },
    });
  })

  .component('newsPost', newsPostComponent);

export default newsPostModule;
